<template>
  <span class="eyebrow">
    <span v-if="pulse" class="pulse" aria-hidden="true" />
    <slot />
  </span>
</template>

<script setup lang="ts">
defineProps<{ pulse?: boolean }>();
</script>
